import React from 'react';
import { Button } from 'semantic-ui-react';
import { observer } from 'mobx-react';

import Modal from '../../shared/Modal/';
import store from './fileReviewStore';
import dashboardStore from '@stores/dashboard';
import iframe from '@components/dashboard-routes/Iframe/iframeData';

function ModalAlert({ onCancel }) {
  const { open, modalParams } = store;
  const openNewUI = () => {
    const { id, step = 0, name } = modalParams;
    if (name) {
      localStorage.setItem('SupplementaryCaseId', 'New Supplementary Report');
      dashboardStore.close('/view/add-edit-supplementary-report-2');
      setTimeout(() => {
        dashboardStore.open(`/view/add-edit-supplementary-report-2?caseNo=${name}&mType=F&mId=${id}`);
      });
    } else {
      dashboardStore.close('/view/add-edit-file-review-2');
      setTimeout(() => {
        dashboardStore.open(`/view/add-edit-file-review-2?id=${id}&step=${step}`);
      });
    }
    onCancel();
  };
  const openOldUI = () => {
    const { id, type, name = '' } = modalParams;
    if (name) {
      return iframe.forceOpenTab('PostSupplementary', `?mId=${id}&mType=A&view=PostSupplementary`, {
        mId: id,
        mType: 'A',
        view: 'PostSupplementary',
      });
    }
    iframe.forceOpenTab('PostFileReview', `?id=${id}&view=PostFileReview#${type}`, {
      id,
      view: 'PostFileReview',
    });
    onCancel();
  };
  return (
    <Modal
      visible={open}
      width={600}
      onCancel={onCancel}
      footer={
        <React.Fragment>
          <Button color="red" onClick={onCancel}>
            Close
          </Button>
        </React.Fragment>
      }
    >
      <div className="Modal-confirm-open-newui">
        <Button className="blue" style={{ marginRight: '10px' }} onClick={openNewUI}>
          Case Detail New UI (Beta)
        </Button>
        <Button className="blue" onClick={openOldUI}>
          Case Detail Old UI
        </Button>
      </div>
    </Modal>
  );
}

export default observer(ModalAlert);
